import { Pipe, PipeTransform } from '@angular/core';
import { parseJSON } from 'date-fns';

@Pipe({
  name: 'toDatePipe',
})
export class ToDatePipe implements PipeTransform {
  transform(value: string | undefined | Date): Date | null {
    return value ? parseJSON(value) : null
  }
}
